import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useUnmount from '../../../shared/hooks/use-unmount';
import { useAppSelector } from '../../../store/hooks';
import { closeAlert, makeSelectAlertStateById } from '../store/ui-slice';

const useAlertState = (modalId: string) => {
  const dispatch = useDispatch();
  const selectAlertStateById = useMemo(makeSelectAlertStateById, []);

  useUnmount(() => {
    dispatch(closeAlert({ id: modalId }));
  });

  return useAppSelector(state => selectAlertStateById(state, modalId));
};

export default useAlertState;
